import { useMemo } from 'react';

import { ProgressBarItem } from 'components/ProgressBar';
import { useStatusContext } from 'pages/Status/context';

import { DECLINED_STEPS } from './constants';
import { getFinanceSteps, getNonFinanceSteps } from './helpers';

import { getLenderStatus } from '../helpers';

export interface ProgressSidebarHook {
  items: ProgressBarItem[];
  isLoading: boolean;
}

export default function useProgressSidebar(): ProgressSidebarHook {
  const {
    isLoading,
    job,
    credit,
    provider,
    deposit,
    isFinanced,
    isPaidByBank,
    isPaidByCard,
    isDeclined,
  } = useStatusContext();

  const lenderStatus = useMemo(
    () =>
      getLenderStatus(job, credit, provider, deposit, isFinanced, isLoading),
    [job, credit, provider, deposit, isFinanced, isLoading],
  );

  const items: ProgressBarItem[] = useMemo(() => {
    if (isDeclined) return DECLINED_STEPS;
    if (isPaidByBank || isPaidByCard) return getNonFinanceSteps(lenderStatus);
    return getFinanceSteps(lenderStatus);
  }, [isDeclined, isPaidByBank, isPaidByCard, lenderStatus]);

  return {
    items,
    isLoading,
  };
}
